import Head from "next/head";
import { IMAGE_PREFIX } from "~/core/constants";
import { ProjectDocument } from "~/core/types";

function generateDesc(str: string) {
  let desc =
    "Web3 community building with high-quality access lists for Solana, Flow, Avalanche, Polygon, Klaytn and Ethereum projects, NFT giveaways and raffles; all free";
  const match = str.match(/<p>([\s\S]*)?<\/p>/i) || [];

  if (match[1]) {
    desc =
      match[1].length > 160 ? `${match[1].substring(0, 157)}...` : match[1];
  }

  return desc;
}

export default function ProjectMetadata({
  project: { id, name, desc, slug, twitter },
}: {
  project: ProjectDocument;
}) {
  const title = `${name} | Hype.Day`;
  const description = generateDesc(desc || "");
  const imageUrl = `${IMAGE_PREFIX}project/${id}/image.jpg`;

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" key="og:title" content={title} />
      <meta
        property="og:description"
        key="og:description"
        content={description}
      />
      <meta
        property="og:url"
        key="og:url"
        content={`https://hype.day/p/${slug}`}
      />
      <meta property="og:image" key="og:image" content={imageUrl} />
      <meta
        name="twitter:card"
        key="twitter:card"
        content="summary_large_image"
      />
      <meta
        name="twitter:image:alt"
        key="twitter:image:alt"
        content={description}
      />
      <meta name="twitter:site" key="twitter:site" content="@hypedotday" />
      {twitter?.isFollowRequired && twitter?.follow ? (
        <meta
          name="twitter:creator"
          key="twitter:creator"
          content={`@${
            twitter.follow
              .split(",")
              .map((element: string) => element.trim())[0]
          }`}
        />
      ) : null}
    </Head>
  );
}
